import { Body, dsSizing } from '@Backlot-Cars/archie';
import { media } from 'public/styles';
import styled from 'styled-components';

export const LookupDetailsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: ${dsSizing.spacing.md};

	@media ${media.smaller} {
		grid-template-columns: 1fr;
	}
`;

export const Value = styled(Body)`
	overflow-wrap: break-word;
`;
